import React, { useState } from "react";
import { createPortal } from "react-dom";
import "./calendar.css";
import useMonthCalendar from "../../hooks/calendar/useMonthCalendar";

const MonthView = ({
  date,
  appointments = [],
  employeeColors = [],
  unavailableEmployees = [],
  showModalShortcut = false,
}) => {
  const { daysName, days, getEvents, getEmployeeColor, isToday } =
    useMonthCalendar(date, appointments, employeeColors, unavailableEmployees);
  const [hoveredAppointment, setHoveredAppointment] = useState(null);

  const showTooltip = (event, app) => {
    const rect = event.currentTarget.getBoundingClientRect();

    setHoveredAppointment({
      app,
      top: rect.top,
      left: rect.right + 10,
    });
  };

  const hideTooltip = () => {
    setHoveredAppointment(null);
  };
  return (
    <>
      <div className="month-calendar">
        <div className="row g-0">
          {daysName.map((day) => (
            <div key={day} className="col month-header">
              {day}
            </div>
          ))}
        </div>

        <div className="calendar-grid">
          {days.map((day, index) => {
            const dayEvents = day ? getEvents(day) : [];

            return (
              <div key={index} className="month-cell">
                {day && (
                  <>
                    <div
                      className={`day-number ${isToday(day) ? "today" : ""}`}
                    >
                      {day.getDate()}
                    </div>

                    <div
                      className="events-container"
                      onClick={() => {
                        showModalShortcut(day, "00:00:00");
                      }}
                    >
                      {dayEvents.map((eve) => {
                        if (eve.type == "appointment") {
                          return (
                            <div
                              key={eve.id}
                              className="month-event"
                              style={{
                                backgroundColor: getEmployeeColor(
                                  eve.staffName,
                                ),
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                              }}
                              onMouseEnter={(e) => showTooltip(e, eve)}
                              onMouseLeave={hideTooltip}
                            >
                              <b>{eve.startTime.slice(0, 5)}</b> {eve.client}
                            </div>
                          );
                        } else {
                          return (
                            <div
                              key={eve.id}
                              className="month-event unavailable"
                              style={{
                                backgroundColor: "lightblue",
                              }}
                            >
                              <b>{eve.startTime?.slice(0, 5)}</b> {eve.barber} -{" "}
                              {eve.reason}
                            </div>
                          );
                        }
                      })}
                    </div>
                  </>
                )}
              </div>
            );
          })}
        </div>
      </div>
      {/* IMPORTANT: tooltip is outside month-calendar */}
      {hoveredAppointment &&
        createPortal(
          <div
            className="calendar-tooltip"
            style={{
              position: "fixed",
              top: hoveredAppointment.top,
              left: hoveredAppointment.left,
            }}
            onMouseEnter={() => {
              // Keep tooltip visible
            }}
            onMouseLeave={hideTooltip}
          >
            <div>
              <strong>{hoveredAppointment.app.client}</strong>
            </div>

            <div>Time: {hoveredAppointment.app.startTime.slice(0, 5)}</div>

            <div>{`Staff: ${hoveredAppointment.app.staffName}`}</div>
          </div>,
          document.body,
        )}{" "}
    </>
  );
};

export default MonthView;
